import { CSSProperties } from 'react'
import { Colors, ColorName } from '@kvika/audur-theme'

import ImageCard from '../../components/imageCard/ImageCard'
import LinkCard from '../../components/linkCard/LinkCard'
import { GridItem, MainGridContainer } from '../../components/grid-container'
import { ColumnClass, Gutters } from '../../utils/types/Types'
import { TranslatedStrings } from '../../utils/translations/TranslatedStrings'
import { Route } from '../../utils/navigation/Routes'

import styles from './AudurWelcomeContent.module.scss'

type Props = {
	style?: CSSProperties
}

const AudurWelcomeContent = ({ style }: Props) => {
	const { home } = TranslatedStrings.is
	return (
		<MainGridContainer
			backgroundColor={Colors.LightOrange}
			gutters={Gutters.Both}
			style={{ paddingBottom: 0, ...style }}
		>
			<>
				<GridItem className={ColumnClass.Left} style={{ justifyContent: 'center' }}>
					<ImageCard
						imageSource={{
							src: '/svg/flower_v2.svg',
							alt: 'flower',
							width: 800,
							height: 1080,
						}}
					/>
				</GridItem>
				<GridItem className={ColumnClass.Right} style={{ justifyContent: 'center' }}>
					<LinkCard
						style={{ paddingBottom: 64 }}
						className={styles.heading}
						heading={<div className={ColorName.DarkGray}>{home.helloContent.headline}</div>}
						subHeading={
							<div className={ColorName.DarkGray}>
								<h4>{home.helloContent.subheadline}</h4>
							</div>
						}
						linkSource={{
							href: Route.Savings,
							title: home.helloContent.linkText,
							fillColor: Colors.DarkGray,
						}}
						secondLinkSource={{
							href: Route.AudurApp,
							title: home.mainContent.linkText,
						}}
					/>
				</GridItem>
			</>
		</MainGridContainer>
	)
}

export default AudurWelcomeContent
